import { useContext, useEffect, useState } from 'react';
import {
  Box,
  Fab,
  FormControlLabel,
  Grid,
  InputLabel,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
  RadioGroup,
  Switch,
  Typography,
} from '@mui/material';
import { Add, Group } from '@mui/icons-material';
import { Controller, useForm } from 'react-hook-form';
import { DropsContext } from 'contexts/DropsContext';
import { ProdutosShopeeContext } from 'contexts/ProdutosShopeeContext';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Loader from 'components/Loader';
import Header from 'components/Header';
import Button from 'components/Button';
import Card from 'components/Card';
import styles from './styles';
import Input from 'components/Input';

const Configurações = () => {
  const defaultValues = {
    id: null,
    cxconta_id: null,
    user_notification: null,
    plano_venda: null,
    plano_venda_full: null,
    plano_frete: null,
    plano_tarifa: null,
    impressora_id: null,
    separate_kit: false,
    celocal_id: null,
  };
  const [selected, setSelected] = useState(null);
  const [contas, setContas] = useState([]);
  const { drops } = useContext(DropsContext);
  const { getLoading, postLoading, getConfig, postConfig, getAuthURL } =
    useContext(ProdutosShopeeContext);
  const { control, watch, setValue, handleSubmit } = useForm({ defaultValues });

  const loadData = () => {
    getConfig({ cb: setContas });
    setSelected(null);
  };

  useEffect(() => {
    getConfig({ cb: setContas });
  }, []);

  useEffect(() => {
    const conta = contas?.find((f) => f?.id === selected)?.access_data;
    setValue('id', selected || null);
    setValue('user_notification', conta?.user_notification || null);
    setValue('plano_venda', conta?.plano_venda || null);
    setValue('plano_venda_full', conta?.plano_venda_full || null);
    setValue('plano_frete', conta?.plano_frete || null);
    setValue('plano_tarifa', conta?.plano_tarifa || null);
    setValue('cxconta_id', conta?.cxconta_id || null);
    setValue('impressora_id', conta?.impressora_id || null);
    setValue('celocal_id', conta?.celocal_id || null);
    setValue('separate_kit', conta?.separate_kit || false);
  }, [selected]);

  const onSubmit = ({ id, ...access_data }) =>
    postConfig({ data: { id, access_data }, cb: loadData });

  const onAdd = () => {
    const result = window.confirm(
      'Confirme se a conta que irá autenticar é a que possui os anúncios que deseja integrar com o sistema'
    );

    if (result) {
      getAuthURL({ cb: (url) => window.open(url, '_blank') });
    }
  };

  if (getLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <Header titulo="Configurações da Integração" />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} display="flex">
          <Card title="Contas" style={styles?.card}>
            {Boolean(contas?.length) ? (
              <List>
                {contas?.map((c, i) => (
                  <ListItemButton
                    divider={i + 1 < contas?.length}
                    key={`${c?.id}`}
                    selected={selected === c?.id}
                    onClick={() => setSelected(c?.id)}
                  >
                    <ListItemIcon>
                      <Group />
                    </ListItemIcon>
                    <ListItemText primary={c?.access_data?.shop_id} />
                  </ListItemButton>
                ))}
              </List>
            ) : (
              <Typography variant="caption">
                Nenhuma conta encontrada
              </Typography>
            )}
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={8} display="flex">
          <Card title="Configurações" style={styles?.card}>
            {Boolean(selected) ? (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Dropdown
                    name="user_notification"
                    control={control}
                    label="Usuário para receber notificações"
                    options={drops?.Users}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Dropdown
                    name="plano_venda"
                    control={control}
                    label="Plano de contas das vendas"
                    options={drops?.Planoconta?.filter(
                      (p) => p?.operacional === 'SIM'
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Dropdown
                    name="plano_venda_full"
                    control={control}
                    label="Plano de contas das vendas do full"
                    options={drops?.Planoconta?.filter(
                      (p) => p?.operacional === 'SIM'
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Dropdown
                    name="plano_frete"
                    control={control}
                    label="Plano de contas do frete"
                    options={drops?.Planoconta?.filter(
                      (p) => p?.operacional === 'SIM'
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Dropdown
                    name="plano_tarifa"
                    control={control}
                    label="Plano de contas das tarifas"
                    options={drops?.Planoconta?.filter(
                      (p) => p?.operacional === 'SIM'
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Dropdown
                    name="cxconta_id"
                    control={control}
                    label="Conta bancária"
                    options={drops?.Cxconta}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Dropdown
                    name="impressora_id"
                    control={control}
                    label="Impressora de etiqueta de expedição"
                    options={drops?.Impressoraweb}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Dropdown
                    name="celocal_id"
                    control={control}
                    label="Local de estoque a movimentar"
                    options={drops?.LocalEstoque}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <Switch
                      checked={watch('separate_kit')}
                      onChange={(_, v) => setValue('separate_kit', v)}
                    />
                    <InputLabel variant="body2">
                      Separar os kits em estrutura nos pedidos
                    </InputLabel>
                  </Box>
                </Grid>
                <Grid item xs={12} textAlign="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit(onSubmit)}
                    loading={postLoading}
                  >
                    Salvar
                  </Button>
                </Grid>
              </Grid>
            ) : (
              <Typography variant="caption">
                Nenhuma conta selecionada
              </Typography>
            )}
          </Card>
        </Grid>
      </Grid>
      <Fab color="primary" onClick={onAdd} style={styles?.fab}>
        <Add />
      </Fab>
    </Container>
  );
};

export default Configurações;
